import React from 'react';
import ReactDOM from 'react-dom/client';

import { ThemeProvider } from '@material-ui/core/styles';

import App from './Components/App';
import theme from './styling/theme';

import './styling/index.css';
import './styling/loadingIcon.css';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';


const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
    <ThemeProvider theme={theme}>
      <App />
    </ThemeProvider>
)
